import Mediator from 'gisw/Classes/Mediator';

class JSTManager {
  /**
   * Specific tool event
   * @param {any} label i.e tool name
   * @param {any} action The action of the label
   * @param {any} msg Any additional comment
   * @param {any} [lat] latitude of the event
   * @param {any} [long] longitude of the event
   */
  jstToolEvent (label, action, msg, lat, long) {
    this.jstEvent('Tool', label, action, msg, lat, long, null);
  }

  /**
   * Map event
   * @param {any} label i.e tool name
   * @param {any} action The action of the label
   * @param {any} msg Any additional comment
   * @param {any} lat latitude of the event
   * @param {any} long longitude of the event
   */
  jstMapEvent (label, action, msg, lat, long) {
    this.jstEvent('Map', label, action, msg, lat, long, null);
  }

  /**
   * Error event
   * @param {any} category i.e tool
   * @param {any} label i.e tool name
   * @param {any} action The action of the label
   * @param {any} msg Any additional comment
   * @param {any} [lat] latitude of the event
   * @param {any} [long] longitude of the event
   */
  jstError (category, label, action, msg, lat, long) {
    this.jst('Error', category, label, action, msg, lat, long, null);
  }

  /**
   * Warning
   * @param {any} category i.e tool
   * @param {any} label i.e tool name
   * @param {any} action The action of the label
   * @param {any} msg Any additional comment
   * @param {any} [lat] latitude of the event
   * @param {any} [long] longitude of the event
   */
  jstWarn (category, label, action, msg, lat, long) {
    this.jst('Warn', category, label, action, msg, lat, long, null);
  }

  /**
   * Send specific event
   * @param {any} category i.e tool
   * @param {any} label i.e tool name
   * @param {any} action The action of the label
   * @param {any} msg Any additional comment
   * @param {any} lat latitude of the event
   * @param {any} long longitude of the event
   * @param {any} json JSON string
   */
  jstEvent (category, label, action, msg, lat, long, json) {
    this.jst('Event', category, label, action, msg, lat, long, json);
  }

  /**
   * Send events
   * @param {any} logLevel i.e Event, Info, Error, Warn...
   * @param {any} category i.e tool
   * @param {any} label i.e tool name
   * @param {any} action The action of the label
   * @param {any} msg Any additional comment
   * @param {any} lat latitude of the event
   * @param {any} long longitude of the event
   * @param {any} json JSON string
   */
  // eslint-disable-next-line class-methods-use-this
  jst (logLevel, category, label, action, msg, lat, long, json) {
    if (process.env.NODE_ENV === 'development') {
      console.debug({
        logLevel,
        category,
        label,
        action,
        msg,
        lat,
        long,
        json
      });
      return;
    }

    if (
      window.location.href.includes('localhost') ||
      process.env.NODE_ENV !== 'production'
    ) {
      return;
    }

    // Use try catch to prevent other functions from breaking if this fails.
    try {
      $.ajax({
        url: '/jst/',
        data: {
          entity: Mediator.serverData.entityName.toLowerCase(),
          department: Mediator.currentTab,
          loglevel: logLevel,
          category,
          label,
          action,
          lat,
          'long': long,
          msg,
          json: json && json.replace(/&/g, '%amp;')
        },
        type: 'GET'
      });
    } catch (err) {
      // No further handling, do nothing
    }
  }
}

export default JSTManager;
